<h2 mat-dialog-title>{{ 'printerTableAddPrinterDialog.heading' | translate }}</h2>
<mat-dialog-content>
  <mat-form-field appearance="fill">
    <!--  PrinterType  -->
    <mat-label>{{ 'printerTableAddPrinterDialog.printerType' | translate }}</mat-label>
    <mat-select formControlName="printerTypeValidator">
      @for (printerType of printerTypes; track printerType) {
        <mat-option (onSelectionChange)="onPrinterTypeChange(printerType.prefix)" [value]="printerType.prefix">{{ printerType.type }}
        </mat-option>
      }
    </mat-select>
    @if (!isPrinterTypeSelected) {
      <mat-hint>
        {{ 'printerTableAddPrinterDialog.printerTypesRequired' | translate }}
      </mat-hint>
    }
  </mat-form-field>
  <mat-form-field appearance="fill">
    <!--  PrinterName  -->
    <mat-label>{{ 'printerTableAddPrinterDialog.printerName' | translate }}</mat-label>
    <input matInput placeholder="Zebra01" [(ngModel)]="data.name" [formControl]="noSpecialCharsValidatorName"
      minlength="1" maxlength="30" required>
      <!--    <input matInput placeholder="Zebra01" [value]="data.name" [formControl]="noSpecialCharsValidatorName"-->
      <!--           minlength="1" maxlength="30" required>-->
      @if (noSpecialCharsValidatorName.value) {
        <button mat-button matSuffix aria-label="Clear"
          (click)="noSpecialCharsValidatorName.setValue(''); isPrinterTypeSelected=false">
          <mat-icon>close</mat-icon>
        </button>
      }
      <mat-hint align="end">{{ noSpecialCharsValidatorName.value?.length || 0 }}/30</mat-hint>
      @if (noSpecialCharsValidatorName.hasError('required')) {
        <mat-error>
          {{ 'printerTableAddPrinterDialog.printerNameRequired' | translate }}
        </mat-error>
      }
      @if (noSpecialCharsValidatorName.hasError('pattern')) {
        <mat-error>
          {{ 'printerTableAddPrinterDialog.printerNameValid' | translate }}
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="fill">
      <!--  PrinterConnection  -->
      <mat-label>{{ 'printerTableAddPrinterDialog.printerConnection' | translate }}</mat-label>
      <input matInput placeholder="192.168.56.100" [(ngModel)]="data.deviceURI"
        [formControl]="noSpecialCharsValidatorConnection" minlength="1" maxlength="250" required>
        <span matPrefix>socket://&nbsp;</span>
        <span matSuffix>:9100</span>
        <mat-hint align="end">{{ data.deviceURI?.length || 0 }}/250</mat-hint>
        @if (noSpecialCharsValidatorConnection.errors?.required) {
          <mat-error>
            {{ 'printerTableAddPrinterDialog.printerConnectionRequired' | translate }}
          </mat-error>
        }
        @if (noSpecialCharsValidatorConnection.errors?.pattern) {
          <mat-error>
            {{ 'printerTableAddPrinterDialog.printerConnectionValid' | translate }}
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="fill">
        <!--  PrinterDescription  -->
        <mat-label>{{ 'printerTableAddPrinterDialog.printerDescription' | translate }}</mat-label>
        <input matInput placeholder="Druckerbeschreibung" [(ngModel)]="data.description">
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>{{ 'printerTableAddPrinterDialog.printerLocation' | translate }}</mat-label>
        <input matInput placeholder="1. Stock" [(ngModel)]="data.location">
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onNoClick()">{{ 'printerTableAddPrinterDialog.abort' | translate }}</button>
      <button mat-raised-button color="primary"
        [mat-dialog-close]="data">{{ 'printerTableAddPrinterDialog.add' | translate }}
      </button>

      <!--          *ngIf="!noSpecialCharsValidatorName.errors?.pattern && !noSpecialCharsValidatorName.errors?.pattern"-->

    </mat-dialog-actions>
